﻿import { containerEmptyingsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("container-emptying"),
  endpoint: "container-emptyings",
  operations: containerEmptyingsOps,
  roleView: [ROLE.AUTO_READOUT_VIEW],
  roleAdmin: [ROLE.AUTO_READOUT_VIEW],
  singularName: (t) => t("Container emptying"),
  name: (t) => t("Container emptyings"),
  initialFilter: { sortBy: "receivedOn", sortOrder: "descend" },
  syncCustomerFilter: true,
});

export default conf;
